module.exports = __webpack_public_path__ + "static/media/16.95db312a.jpeg";